import { AnalyticsEventParam } from '@accedo/one-plugin-sdk';
import { useMemo } from 'react';

import { useConfig } from '#/hooks';
import { useActiveMvpd } from '#/hooks/useActiveMvpd';
import {
  browserVersion,
  detectBrowserName,
  detectDeviceType,
  detectOsName,
  detectOsVersion,
  detectPlatformMake,
  detectPlatformModel,
  detectScreenResolution,
  userAgent,
} from '#/service/deviceInfo';
import { getDeviceId } from '#/service/user/userSessionManager';
import { useAuthentication } from '#/store/auth';

export const useAppAnalyticsContext = () => {
  const { app } = useConfig();
  const { userId, sessionId, profile } = useAuthentication();
  const { name } = useActiveMvpd() || {};

  // The default value for each property should be null instead of undefined
  return useMemo(() => {
    const deviceId = getDeviceId();

    return {
      [AnalyticsEventParam.AppName]: app.name,
      [AnalyticsEventParam.AppVersion]: app.version || null,
      [AnalyticsEventParam.BrowserName]: detectBrowserName(),
      [AnalyticsEventParam.BrowserVersion]: browserVersion,
      // `DeviceId` is deprecated, because it was renamed to `PlatformDeviceId`.
      // but we want to keep it here for now, because some plugins are still using it.
      // that's why I'm disabling sonar for the next line.
      [AnalyticsEventParam.DeviceId]: deviceId, //NOSONAR
      [AnalyticsEventParam.Mvpd]: name || null,
      [AnalyticsEventParam.PlatformDeviceId]: deviceId,
      [AnalyticsEventParam.PlatformDeviceType]: detectDeviceType(),
      [AnalyticsEventParam.PlatformMake]: detectPlatformMake(),
      [AnalyticsEventParam.PlatformModel]: detectPlatformModel(),
      [AnalyticsEventParam.PlatformOs]: detectOsName(),
      [AnalyticsEventParam.PlatformOsVersion]: detectOsVersion(),
      [AnalyticsEventParam.PlatformType]: 'Web',
      [AnalyticsEventParam.PlatformUserAgent]: userAgent,
      [AnalyticsEventParam.ScreenResolution]: detectScreenResolution(),
      [AnalyticsEventParam.SessionId]: sessionId || null,
      [AnalyticsEventParam.SiteDomain]: window.location.hostname,
      [AnalyticsEventParam.SiteUrl]: window.location.href,
      [AnalyticsEventParam.UserId]: userId || null,
      [AnalyticsEventParam.UserProfile]: profile,
    };
  }, [app, name, sessionId, userId, profile]);
};
